// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"52b39636","208":"d7437938","211":"b461361a","420":"fde71839","592":"8231306f","796":"b23b6635","804":"cb835d9f"}[chunkId] + ".chunk.js";
};